import type { Ref } from 'vue';
import {
  computed,
  toRef,
} from 'vue';

import type { AllowedNamespace } from '@modules/permissions/types';
import { ERouteNamespace } from '@modules/core/services/router/enums';

import useNamespaceStore from '../store/useNamespaceStore';

export interface PermissionNamespaceComposable {
  namespace: Ref<AllowedNamespace | undefined>;
  isAdminNamespace: Ref<boolean>;
  isAffiliateNamespace: Ref<boolean>;
}

export default function useCurrentNamespace(): PermissionNamespaceComposable {
  const namespace = toRef(useNamespaceStore(), 'namespace');
  const isAdminNamespace = computed(() => namespace.value === ERouteNamespace.ADMIN);
  const isAffiliateNamespace = computed(() => namespace.value === ERouteNamespace.AFFILIATE);

  return {
    namespace,
    isAdminNamespace,
    isAffiliateNamespace,
  };
}
